const MOBILE_LAYOUT_BREAKPOINT = 640;

export function useOverlayVariant(viewportWidth: number) {
  return viewportWidth < MOBILE_LAYOUT_BREAKPOINT ? 'sheet' : 'modal';
}
